import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Label
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { accessRole } from '../../../../../helpers/access_role'
import Select from '../../../../../helpers/ui/CustomSelect'
import { Preview } from '../../../../../helpers/ui/FileInput'
import { AvForm, AvField } from "availity-reactstrap-validation"
import Shimmer from "react-shimmer-effect";
import moment from 'moment'

import { Link, Redirect, withRouter } from "react-router-dom"

import apiResponse from '../../../../../services/apiResponse'
import { cancelToken } from '../../../../../services/adapters/kepegawaian/menuService'

import IndexBloc from '../Index/Blocs/IndexBloc'
class DetailView extends Component {
    source
    indexBloc = new IndexBloc()

    constructor(props) {
        super(props)
        this.state = {
            detail: {},
            loading: true
        }
    }

    loadDetail = async () => {
        const query = {
            uuid: this.props.uuid
        }
        await this.indexBloc.fetchDetail(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadDetail()
    }

    componentDidMount() {
        this.setTokenAPI()

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response, loading: false })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })
    }

    render() {
        const { detail } = this.state
        const status = ['Menunggu Persetujuan', 'Disetujui', 'Ditolak']
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody>
                                    <div className="float-end">
                                        <Link to='/izinpegawai/dinas.html'>
                                            <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                        </Link>
                                    </div>
                                    <CardTitle>Perjalanan Dinas</CardTitle>
                                    <CardSubtitle className="mb-3">
                                    </CardSubtitle>
                                    <hr />

                                    {
                                        this.state.loading == true ?
                                            <>
                                                <Row className="mb-3">
                                                    <Col md={8}>
                                                        <Shimmer>
                                                            <div style={{ width: "90%", height: 30 }}></div>
                                                        </Shimmer>
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Col md={8}>
                                                        <Shimmer>
                                                            <div style={{ width: "80%", height: 30 }}></div>
                                                        </Shimmer>
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Col md={8}>
                                                        <Shimmer>
                                                            <div style={{ width: "50%", height: 30 }}></div>
                                                        </Shimmer>
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Col md={8}>
                                                        <Shimmer>
                                                            <div style={{ width: "70%", height: 30 }}></div>
                                                        </Shimmer>
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Col md={8}>
                                                        <Shimmer>
                                                            <div style={{ width: "30%", height: 30 }}></div>
                                                        </Shimmer>
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Col md={8}>
                                                        <Shimmer>
                                                            <div style={{ width: "40%", height: 30 }}></div>
                                                        </Shimmer>
                                                    </Col>
                                                </Row>
                                            </>
                                        :
                                        <AvForm
                                            className="needs-validation"
                                            onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                        >
                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                    Nomor 
                                                </Label>
                                                <Col md="4">
                                                    <AvField 
                                                        type="text" 
                                                        placeholder="Nomor Perjalanan Dinas"
                                                        errorMessage="Masukkan Nomor Perjalanan Dinas"
                                                        className="form-control"
                                                        name="official_travel_number"
                                                        value={detail?.official_travel_number}
                                                        readOnly="true" />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                    Tanggal Mulai 
                                                </Label>
                                                <Col md="2">
                                                    <AvField
                                                        name="official_travel_date"
                                                        placeholder="Tanggal Perjalanan Dinas"
                                                        errorMessage="Masukkan Tanggal Perjalanan Dinas"
                                                        className="form-control"
                                                        readOnly={true}
                                                        value={moment(detail?.official_travel_start_date).format("DD MMMM YYYY")}
                                                        validate={{ required: { value: true } }}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                    Tanggal Selesai Dinas 
                                                </Label>
                                                <Col md="2">
                                                    <AvField
                                                        name="official_travel_end_date"
                                                        placeholder="Tanggal Selesai Perjalanan Dinas"
                                                        errorMessage="Masukkan Tanggal Selesai Perjalanan Dinas"
                                                        className="form-control"
                                                        readOnly={true}
                                                        value={moment(detail?.official_travel_end_date).format("DD MMMM YYYY")}
                                                        validate={{ required: { value: true } }}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                    Tempat Dinas 
                                                </Label>
                                                <Col md="3">
                                                    <AvField
                                                        name="official_travel_date"
                                                        type="text"
                                                        readOnly={true}
                                                        value={detail?.official_travel_oversea == 1 ? 'Dalam Negeri' : 'Luar Negeri'}
                                                        validate={{ required: { value: true } }}
                                                    />
                                                </Col>
                                            </Row>

                                            {detail?.official_travel_oversea == 1 &&
                                                <Fragment>
                                                    <Row className="mb-3">
                                                        <Label
                                                            className="col-md-2 col-form-label"
                                                        >
                                                        </Label>
                                                        <Col md="3">
                                                            <AvField
                                                                name="official_travel_date"
                                                                type="text"
                                                                readOnly={true}
                                                                value={detail?.official_travel_domicile == 1 ? 'Dalam Kota' : 'Luar Kota'}
                                                                validate={{ required: { value: true } }}
                                                            />
                                                        </Col>
                                                    </Row>

                                                    {detail?.official_travel_domicile == 2 &&
                                                        <Fragment>
                                                            <Row className="mb-3">
                                                                <Label
                                                                    className="col-md-2 col-form-label"
                                                                >
                                                                Provinsi 
                                                                </Label>
                                                                <Col md="3">
                                                                    <AvField
                                                                        name="official_travel_date"
                                                                        type="text"
                                                                        readOnly={true}
                                                                        value={detail?.official_travel_province}
                                                                        validate={{ required: { value: true } }}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            <Row className="mb-3">
                                                                <Label
                                                                    className="col-md-2 col-form-label"
                                                                >
                                                                    Kota 
                                                                </Label>
                                                                <Col md="3">
                                                                    <AvField
                                                                        name="official_travel_date"
                                                                        type="text"
                                                                        readOnly={true}
                                                                        value={detail?.official_travel_city}
                                                                        validate={{ required: { value: true } }}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </Fragment>
                                                    }

                                                </Fragment>
                                            }

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                    Tujuan 
                                                </Label>
                                                <Col md="5">
                                                    <AvField
                                                        name="official_travel_destination"
                                                        placeholder="Tujuan Perjalanan Dinas"
                                                        type="textarea"
                                                        rows="5"
                                                        errorMessage="Masukkan Tujuan Perjalanan Dinas"
                                                        className="form-control"
                                                        value={detail?.official_travel_destination}
                                                        readOnly="true"
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                    Keterangan 
                                                </Label>
                                                <Col md="5">
                                                    <AvField
                                                        name="official_travel_description"
                                                        placeholder="Keterangan Perjalanan Dinas"
                                                        type="textarea"
                                                        rows="5"
                                                        className="form-control"
                                                        value={detail?.official_travel_description}
                                                        readOnly="true"
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <Label className="col-md-2 col-form-label">
                                                    Surat Tugas
                                                </Label>
                                                <Col md="5">
                                                    <Preview value={detail?.document} col="5" />
                                                </Col>
                                            </Row>

                                            <Fragment>
                                                {detail?.participant?.map((val, i) => {
                                                    let type = val.official_travel_participant_type;
                                                    let name = val.official_travel_participant_ext_name;
                                                    
                                                    if (type == 1 || type == null || type == '') {
                                                        name = val.employee?.employee_name
                                                        let front_title = val.employee?.employee_front_title ? val.employee?.employee_front_title + '. ' : ''
                                                        let end_title = val.employee?.employee_end_title ? ' ' + val.employee?.employee_end_title : ''
                                                        name = front_title + name + end_title
                                                    }
                                                    return (
                                                        <Row className="mb-4">
                                                            {i == 0 ?
                                                                <Label htmlFor="horizontal-password-input" className="col-md-2 col-form-label">Partisipan  </Label>
                                                                :
                                                                <Label htmlFor="horizontal-password-input" className="col-md-2 col-form-label"></Label>
                                                            }
                                                            <Col sm={4}>
                                                                <AvField
                                                                    name="official_travel_participant_employee_uuid[0]"
                                                                    placeholder="Nama Pasrtisipan"
                                                                    type="text"
                                                                    errorMessage="Masukkan Nama Pasrtisipan"
                                                                    className="form-control"
                                                                    value={name}
                                                                    readOnly={true}
                                                                />
                                                            </Col>
                                                        </Row>                                                    
                                                    )
                                                })}
                                            </Fragment>

                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                    Status Approval 
                                                </Label>
                                                <Col md="4">
                                                    <AvField
                                                        name="official_travel_refusal_reason"
                                                        placeholder="Masukkan Alasan Penolakan"
                                                        errorMessage="Masukkan Alasan Penolakan"
                                                        value={status[detail?.official_travel_approval_status]}
                                                        type="text"
                                                        className="form-control"
                                                        readOnly={true}
                                                    />
                                                </Col>
                                            </Row>

                                            {detail?.official_travel_note &&
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Catatan
                                                    </Label>
                                                    <Col md="4">
                                                        <AvField
                                                            name="official_travel_refusal_reason"
                                                            placeholder="Masukkan Alasan Penolakan"
                                                            value={detail?.official_travel_note}
                                                            errorMessage="Masukkan Alasan Penolakan"
                                                            type="textarea"
                                                            className="form-control"
                                                            readOnly={true}
                                                        />
                                                    </Col>
                                                </Row>
                                            }

                                        </AvForm>
                                    }

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }

}

export default withRouter(DetailView)